<script setup>
import analyticEventKeys from '@/constants/analytic-event-keys';

const props = defineProps({
  // all search filters
  modelValue: {
    type: Object,
    default: () => ({}),
  },

  withBack: {
    type: Boolean,
    default: false,
  },
  isFlowFinish: {
    type: Boolean,
    default: false,
  },
  isFlowRunning: {
    type: Boolean,
    default: false,
  },
  modelUpdateMode: {
    type: String,
    default: 'change',
    validator: (value) => ['change', 'submit'].includes(value),
  },
});

const emit = defineEmits([
  'close',
  'back',
  'success',
  'update:modelValue',
  'timeClick',
  'timeClear',
]);

const { t } = useI18n();

const analytics = useGoogleAnalytics();

const modelData = ref(cloneObject(props.modelValue));
watch(
  () => props.modelValue,
  () => {
    modelData.value = cloneObject(props.modelValue);
  },
  { deep: true },
);
const modelValueLocal = computed({
  get() {
    return modelData.value;
  },
  set(value) {
    modelData.value = value;

    if (props.modelUpdateMode === 'change') {
      emit('update:modelValue', value);
    }
  },
});

// roundTrip
const roundTripTabs = [
  {
    id: false,
    iconName: 'single',
    text: t('form.single'),
  },
  {
    id: true,
    iconName: 'return',
    text: t('form.return'),
  },
];
const roundTripModel = computed({
  get() {
    return modelValueLocal.value.roundTrip;
  },
  set(value) {
    modelValueLocal.value.roundTrip = value;

    if (props.modelUpdateMode === 'change') {
      emit('update:modelValue', { roundTrip: value });
    }
  },
});

const buttonText = computed(() => {
  switch (true) {
    case !!props.isFlowRunning && !!props.isFlowFinish:
      return t('form.searchTickets');
    case !!props.isFlowRunning && !props.isFlowFinish:
      return t('form.next');
    default:
      return t('form.set');
  }
});
const isValid = computed(() => {
  const { roundTrip, departureDate, returnDate } = modelValueLocal.value;

  return roundTrip ? !!departureDate && !!returnDate : !!departureDate;
});

function handleSubmit() {
  if (props.modelUpdateMode === 'submit') {
    emit('update:modelValue', modelValueLocal.value);
  }

  emit('success');
}

// Update slider's date values
watch(
  () => modelValueLocal.value.departureDate,
  (value) => {
    if (!value) return;
    analytics.pushEvent({
      event: analyticEventKeys.SEARCH_FORM_INTERACTION,
      label: `input: departure date`,
    });
  },
);
watch(
  () => modelValueLocal.value.returnDate,
  (value) => {
    if (!value) return;
    analytics.pushEvent({
      event: analyticEventKeys.SEARCH_FORM_INTERACTION,
      label: `input: return date`,
    });
  },
);
</script>

<template>
  <FormsSearchScreenWrapper
    class="forms-search-screens-date"
    :name="$t('form.date')"
    :departure-name="modelValue.departureStation?.name"
    :arrival-name="modelValue.arrivalStation?.name"
    :with-back="withBack"
    @close="emit('close')"
    @back="emit('back')"
  >
    <div class="forms-search-screens-date__container">
      <UiTabs
        v-model="roundTripModel"
        class="forms-search-screens-date__tabs"
        :items="roundTripTabs"
      />

      <BundlesCalendar
        v-model="modelValueLocal"
        class="forms-search-screens-date__calendar"
      />

      <!--      <BundlesDateTime-->
      <!--        class="forms-search-screens-date__date-time"-->
      <!--        :model-value="modelValue"-->
      <!--        time-mode="display"-->
      <!--        theme="gray"-->
      <!--        date-size="s"-->
      <!--        @time-click="emit('timeClick')"-->
      <!--        @time-clear="emit('timeClear')"-->
      <!--      />-->

      <UiButton
        class="forms-search-screens-date__button"
        theme="secondary"
        :disabled="!isValid"
        @click="handleSubmit"
      >
        <span class="forms-search-screens-date__font">
          {{ buttonText }}
        </span>
      </UiButton>
    </div>
  </FormsSearchScreenWrapper>
</template>

<style scoped lang="scss">
.forms-search-screens-date {
  &__font {
    font-size: em(20);
    font-weight: 500;
    line-height: math.div(22, 20);
  }

  &__container {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: 0 em(16);
  }

  &__tabs {
    flex-shrink: 0;
  }

  &__calendar {
    flex-grow: 1;
    margin-bottom: em(16);
  }

  //&__date-time {
  //  flex-shrink: 0;
  //  height: em(54);
  //  margin-bottom: em(16);
  //}

  &__button {
    flex-shrink: 0;
    height: em(63);
  }
}
</style>
